import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://flyfinder.ca';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_fishing-companion-4/artifacts/66behbmm_noBgColor.png';

const Seo = ({
  title = "FlyFinder | Know What's Hatching Before You Leave Home",
  description = 'FlyFinder is the AI-powered fly fishing companion. Get real-time fly recommendations, a regional hatch calendar, weather analysis, a digital fly box, trip planning, and a fishing logbook. Start with a 2-week free trial on the App Store.',
  path = '/',
  image = DEFAULT_IMAGE,
}) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
